/**
 * @flow
 * @relayHash 2db519a11af7fc8247fe8f5a12b01bf6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ImageThumbnail_image$ref = any;
type ProfileLink_user$ref = any;
type RankDisplay_plant$ref = any;
type VotingButtons_voting$ref = any;
export type Edibility = "BAD" | "EXCELLENT" | "FAIR" | "GOOD" | "POOR" | "SOME" | "%future added value";
export type RevisionType = "CREATE" | "DELETE" | "UPDATE" | "%future added value";
export type RevisionItemQueryVariables = {|
  revisionID: string
|};
export type RevisionItemQueryResponse = {|
  +revision: ?{|
    +id: string,
    +idInt: ?number,
    +type: ?RevisionType,
    +typeDisplay: ?string,
    +isTip: ?boolean,
    +author: ?{|
      +$fragmentRefs: ProfileLink_user$ref
    |},
    +createdAt: any,
    +after: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +idInt: ?number,
          +createdAt: any,
          +author: ?{|
            +username: string
          |},
        |}
      |}>
    |},
    +before: ?{|
      +id: string,
      +idInt: ?number,
      +createdAt: any,
      +author: ?{|
        +username: string
      |},
    |},
    +object: ?{|
      +id: string,
      +__typename: string,
      +revisionCreated?: ?{|
        +author: ?{|
          +username: string,
          +$fragmentRefs: ProfileLink_user$ref,
        |},
        +createdAt: any,
      |},
      +value?: number,
      +body?: string,
      +title?: string,
      +url?: string,
      +publishedAt?: ?any,
      +tags?: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +slug: string,
            +title: string,
          |}
        |}>
      |},
      +idInt?: ?number,
      +slug?: ?string,
      +description?: ?string,
      +edibility?: ?Edibility,
      +edibilityDisplay?: ?string,
      +commonNames?: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: string,
            +language: ?string,
            +voting: ?{|
              +$fragmentRefs: VotingButtons_voting$ref
            |},
          |}
        |}>
      |},
      +mainImage?: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +smallImage: ?{|
              +url: string
            |},
            +$fragmentRefs: ImageThumbnail_image$ref,
          |}
        |}>
      |},
      +images?: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +smallImage: ?{|
              +url: string
            |},
            +$fragmentRefs: ImageThumbnail_image$ref,
          |}
        |}>
      |},
      +$fragmentRefs: RankDisplay_plant$ref,
    |},
  |}
|};
export type RevisionItemQuery = {|
  variables: RevisionItemQueryVariables,
  response: RevisionItemQueryResponse,
|};
*/


/*
query RevisionItemQuery(
  $revisionID: ID!
) {
  revision(id: $revisionID) {
    id
    idInt
    type
    typeDisplay
    isTip
    author {
      ...ProfileLink_user
      id
    }
    createdAt
    after(first: 50) {
      edges {
        node {
          id
          idInt
          createdAt
          author {
            username
            id
          }
        }
      }
    }
    before {
      id
      idInt
      createdAt
      author {
        username
        id
      }
    }
    object {
      id
      __typename
      ... on DocumentNode {
        revisionCreated {
          author {
            ...ProfileLink_user
            username
            id
          }
          createdAt
          id
        }
      }
      ... on Vote {
        value
      }
      ... on Comment {
        body
      }
      ... on Post {
        title
        body
        url
        publishedAt
        tags(first: 50) {
          edges {
            node {
              slug
              title
              id
            }
          }
        }
      }
      ... on Page {
        title
        body
        url
        publishedAt
      }
      ... on LifeNode {
        idInt
        title
        slug
        description
        edibility
        edibilityDisplay
        ...RankDisplay_plant
        commonNames(first: 20) {
          edges {
            node {
              id
              name
              language
              voting {
                ...VotingButtons_voting
                id
              }
            }
          }
        }
        mainImage: images(first: 1) {
          edges {
            node {
              id
              smallImage: image(width: 225, height: 300) {
                url
              }
              ...ImageThumbnail_image
            }
          }
        }
        images(first: 20) {
          edges {
            node {
              id
              smallImage: image(width: 200, height: 200) {
                url
              }
              ...ImageThumbnail_image
            }
          }
        }
      }
    }
  }
}

fragment ProfileLink_user on User {
  id
  username
  firstName
  reputation
  avatar(width: 40, height: 40) {
    url
  }
}

fragment RankDisplay_plant on LifeNode {
  title
  rankDisplay
  parents {
    id
    idInt
    title
    slug
    rankDisplay
    ...PlantLink_plant
  }
}

fragment VotingButtons_voting on Voting {
  id
  countUps
  countDowns
  sumValues
  mine {
    id
    value
  }
}

fragment ImageThumbnail_image on Image {
  id
}

fragment PlantLink_plant on LifeNode {
  id
  idInt
  title
  slug
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "revisionID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "revisionID"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "idInt",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "typeDisplay",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTip",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "FragmentSpread",
  "name": "ProfileLink_user",
  "args": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v8/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "author",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v10/*: any*/)
    ]
  }
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "type": "Vote",
  "selections": [
    (v13/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "body",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "type": "Comment",
  "selections": [
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedAt",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "type": "Page",
  "selections": [
    (v17/*: any*/),
    (v15/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ]
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "edibility",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "edibilityDisplay",
  "args": null,
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "language",
  "args": null,
  "storageKey": null
},
v28 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v29 = [
  (v18/*: any*/)
],
v30 = {
  "kind": "LinkedField",
  "alias": "smallImage",
  "name": "image",
  "storageKey": "image(height:300,width:225)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 300
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 225
    }
  ],
  "concreteType": "File",
  "plural": false,
  "selections": (v29/*: any*/)
},
v31 = {
  "kind": "FragmentSpread",
  "name": "ImageThumbnail_image",
  "args": null
},
v32 = {
  "kind": "LinkedField",
  "alias": "smallImage",
  "name": "image",
  "storageKey": "image(height:200,width:200)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 200
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 200
    }
  ],
  "concreteType": "File",
  "plural": false,
  "selections": (v29/*: any*/)
},
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "reputation",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "avatar",
      "storageKey": "avatar(height:40,width:40)",
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 40
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 40
        }
      ],
      "concreteType": "File",
      "plural": false,
      "selections": (v29/*: any*/)
    }
  ]
},
v34 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v8/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "author",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v2/*: any*/)
    ]
  }
],
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rankDisplay",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RevisionItemQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "revision",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Revision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "author",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ]
          },
          (v8/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "after",
            "storageKey": "after(first:50)",
            "args": (v9/*: any*/),
            "concreteType": "RevisionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RevisionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Revision",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "before",
            "storageKey": null,
            "args": null,
            "concreteType": "Revision",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "object",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "revisionCreated",
                "storageKey": null,
                "args": null,
                "concreteType": "Revision",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "author",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              (v14/*: any*/),
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "Post",
                "selections": [
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tags",
                    "storageKey": "tags(first:50)",
                    "args": (v9/*: any*/),
                    "concreteType": "TagConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TagEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Tag",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "LifeNode",
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "commonNames",
                    "storageKey": "commonNames(first:20)",
                    "args": (v25/*: any*/),
                    "concreteType": "CommonNameConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommonNameEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommonName",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "voting",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Voting",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "FragmentSpread",
                                    "name": "VotingButtons_voting",
                                    "args": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "mainImage",
                    "name": "images",
                    "storageKey": "images(first:1)",
                    "args": (v28/*: any*/),
                    "concreteType": "ImageConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "images",
                    "storageKey": "images(first:20)",
                    "args": (v25/*: any*/),
                    "concreteType": "ImageConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v32/*: any*/),
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "RankDisplay_plant",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "RevisionItemQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "revision",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Revision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v33/*: any*/),
          (v8/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "after",
            "storageKey": "after(first:50)",
            "args": (v9/*: any*/),
            "concreteType": "RevisionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RevisionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Revision",
                    "plural": false,
                    "selections": (v34/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "before",
            "storageKey": null,
            "args": null,
            "concreteType": "Revision",
            "plural": false,
            "selections": (v34/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "object",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "revisionCreated",
                "storageKey": null,
                "args": null,
                "concreteType": "Revision",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  (v8/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v14/*: any*/),
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "Post",
                "selections": [
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tags",
                    "storageKey": "tags(first:50)",
                    "args": (v9/*: any*/),
                    "concreteType": "TagConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TagEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Tag",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v17/*: any*/),
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "LifeNode",
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v35/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "parents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LifeNode",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v35/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "commonNames",
                    "storageKey": "commonNames(first:20)",
                    "args": (v25/*: any*/),
                    "concreteType": "CommonNameConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommonNameEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommonName",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "voting",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Voting",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "countUps",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "countDowns",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sumValues",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mine",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Vote",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "mainImage",
                    "name": "images",
                    "storageKey": "images(first:1)",
                    "args": (v28/*: any*/),
                    "concreteType": "ImageConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v30/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "images",
                    "storageKey": "images(first:20)",
                    "args": (v25/*: any*/),
                    "concreteType": "ImageConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v32/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "RevisionItemQuery",
    "id": null,
    "text": "query RevisionItemQuery(\n  $revisionID: ID!\n) {\n  revision(id: $revisionID) {\n    id\n    idInt\n    type\n    typeDisplay\n    isTip\n    author {\n      ...ProfileLink_user\n      id\n    }\n    createdAt\n    after(first: 50) {\n      edges {\n        node {\n          id\n          idInt\n          createdAt\n          author {\n            username\n            id\n          }\n        }\n      }\n    }\n    before {\n      id\n      idInt\n      createdAt\n      author {\n        username\n        id\n      }\n    }\n    object {\n      id\n      __typename\n      ... on DocumentNode {\n        revisionCreated {\n          author {\n            ...ProfileLink_user\n            username\n            id\n          }\n          createdAt\n          id\n        }\n      }\n      ... on Vote {\n        value\n      }\n      ... on Comment {\n        body\n      }\n      ... on Post {\n        title\n        body\n        url\n        publishedAt\n        tags(first: 50) {\n          edges {\n            node {\n              slug\n              title\n              id\n            }\n          }\n        }\n      }\n      ... on Page {\n        title\n        body\n        url\n        publishedAt\n      }\n      ... on LifeNode {\n        idInt\n        title\n        slug\n        description\n        edibility\n        edibilityDisplay\n        ...RankDisplay_plant\n        commonNames(first: 20) {\n          edges {\n            node {\n              id\n              name\n              language\n              voting {\n                ...VotingButtons_voting\n                id\n              }\n            }\n          }\n        }\n        mainImage: images(first: 1) {\n          edges {\n            node {\n              id\n              smallImage: image(width: 225, height: 300) {\n                url\n              }\n              ...ImageThumbnail_image\n            }\n          }\n        }\n        images(first: 20) {\n          edges {\n            node {\n              id\n              smallImage: image(width: 200, height: 200) {\n                url\n              }\n              ...ImageThumbnail_image\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProfileLink_user on User {\n  id\n  username\n  firstName\n  reputation\n  avatar(width: 40, height: 40) {\n    url\n  }\n}\n\nfragment RankDisplay_plant on LifeNode {\n  title\n  rankDisplay\n  parents {\n    id\n    idInt\n    title\n    slug\n    rankDisplay\n    ...PlantLink_plant\n  }\n}\n\nfragment VotingButtons_voting on Voting {\n  id\n  countUps\n  countDowns\n  sumValues\n  mine {\n    id\n    value\n  }\n}\n\nfragment ImageThumbnail_image on Image {\n  id\n}\n\nfragment PlantLink_plant on LifeNode {\n  id\n  idInt\n  title\n  slug\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3749199f70dd089a8810e18c430bcea';
module.exports = node;
